import { useState, useCallback, useEffect } from "react";

export default function useBrowserStorage(key, defaultValue, storageObject) {
  const [value, setValue] = useState(() => {
    const storedValue = storageObject.getItem(key);

    return storedValue === null ? defaultValue : JSON.parse(storedValue);
  });

  useEffect(() => {
    const listener = (e) => {
      if (JSON.stringify(e.storageArea) === JSON.stringify(storageObject) && e.key === key) {
        setValue(JSON.parse(e.newValue));
      }
    };

    window.addEventListener("storage", listener);

    return () => {
      window.removeEventListener("storage", listener);
    };
  }, [key, storageObject]);

  const setValueInLocalStorage = useCallback(
    (newValue) => {
      setValue((currentValue) => {
        const result = typeof newValue === "function" ? newValue(currentValue) : newValue;

        storageObject.setItem(key, JSON.stringify(result));

        return result;
      });
    },
    [key, storageObject]
  );

  return [value, setValueInLocalStorage];
}
